import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Title
 *
 * This component is in charge of displaying
 * a page title
 *
 * @return {jsx}
 */

const Title = ({ className, children }) => <h1 className={className}>{children}</h1>;

/**
 * Display Name
 */
Title.displayName = 'Page.Title';

/**
 * PropTypes Validation
 */
const { node, string } = PropTypes;
Title.propTypes = {
  className: string,
  children: node,
};

/**
 * Default Props
 */
Title.defaultProps = {
  className: '',
  children: null,
};

export default styled(Title)`
  font-size: ${({ theme: { fonts } }) => fonts.size.h4};
  font-weight: ${({ theme: { fonts } }) => fonts.weight.thick};

  margin-bottom: ${({ theme: { fonts } }) => fonts.size.big};
`;



// WEBPACK FOOTER //
// ./src/components/Page/Title/index.js